import ConfigParameter, { gettext } from "../ConfigParameter";

export default class Recaptcha extends ConfigParameter {

    constructor() {
        super('recaptcha', 'checkbox', gettext('Show captcha'), 'mainConfig', null, null, null, null, null, gettext('Check it if you want your form secured by Google reCaptcha'));
    }

}



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/Recaptcha.js